import InfoPage from '@/components/InfoPage';

const DireitosAutorais = () => {
  return (
    <InfoPage title="Direitos Autorais">
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Propriedade Intelectual - MARCA REGISTRADA</h2>
          <p>
            Todo o conteúdo do ParkingSpot®, incluindo mas não limitado a textos, gráficos, logos, ícones, imagens, clipes de áudio, downloads digitais e software, é de propriedade da ParkingSpot ou de seus fornecedores de conteúdo e é protegido pelas leis brasileiras e internacionais de direitos autorais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Marca Registrada</h2>
          <p>
            ParkingSpot e o logo da ParkingSpot® são marcas registradas. Todas as outras marcas que aparecem neste site são de propriedade de seus respectivos donos.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Uso Permitido</h2>
          <p>Você pode:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Usar o ParkingSpot para fins pessoais e não comerciais</li>
            <li>Visualizar e baixar material do site para uso pessoal</li>
            <li>Compartilhar informações de estacionamentos disponíveis publicamente</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Uso Proibido</h2>
          <p>Você não pode:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Reproduzir, duplicar, copiar ou revender qualquer parte do serviço para fins comerciais</li>
            <li>Modificar ou adaptar o código fonte da plataforma</li>
            <li>Usar a marca ParkingSpot sem permissão escrita</li>
            <li>Fazer engenharia reversa ou tentar extrair o código fonte</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Conteúdo do Usuário</h2>
          <p>
            Ao enviar informações sobre estacionamentos, você concede à ParkingSpot uma licença não exclusiva, mundial, livre de royalties para usar, reproduzir e exibir esse conteúdo em conexão com o serviço.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>Violação de Direitos Autorais</h2>
          <p>
            Se você acredita que seu trabalho foi copiado de uma forma que constitui violação de direitos autorais, entre em contato:
          </p>
          <p className="mt-2">Email: parkingspotbrasil@gmail.com</p>
          <p className="mt-4">
            © 2025 ParkingSpot - by <a href="https://capibaragroup.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#302681] transition-colors">Capibara Group</a> - Todos os direitos reservados.
          </p>
        </section>
      </div>
    </InfoPage>
  );
};

export default DireitosAutorais;
